// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={219}
    height={137}
    viewBox="0 0 219 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 0H219V137H0V0Z"
      fill="#F8FFFD"
    />
    <path
      d="M126.451 83.5186L130.392 83.5186C134.578 83.5186 137.971 80.1254 137.971 75.9396V75.9396C137.971 71.7539 134.578 68.3607 130.392 68.3607L126.451 68.3607"
      stroke="#37363F"
      strokeWidth={0.86}
      strokeDasharray="1.61 1.61"
    />
    <rect
      x={86.1507}
      y={44.43}
      width={39.7366}
      height={11.0497}
      rx={1.71161}
      fill="white"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <rect
      x={89.6693}
      y={47.678}
      width={4.55288}
      height={4.55352}
      rx={0.640805}
      fill="#38D695"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <mask
      id="path-5-inside-1_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={48.3306}
        width={18.4038}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={48.3306}
      width={18.4038}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-5-inside-1_16632_43168)"
    />
    <mask
      id="path-6-inside-2_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={50.4961}
        width={10.8258}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={50.4961}
      width={10.8258}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-6-inside-2_16632_43168)"
    />
    <rect
      x={86.1507}
      y={61.2117}
      width={39.7366}
      height={11.0497}
      rx={1.71161}
      fill="white"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <rect
      x={89.6693}
      y={64.4598}
      width={4.55288}
      height={4.55352}
      rx={0.640805}
      fill="#38D695"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <mask
      id="path-9-inside-3_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={65.1123}
        width={18.4038}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={65.1123}
      width={18.4038}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-9-inside-3_16632_43168)"
    />
    <mask
      id="path-10-inside-4_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={67.2778}
        width={10.8258}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={67.2778}
      width={10.8258}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-10-inside-4_16632_43168)"
    />
    <rect
      x={86.1507}
      y={77.994}
      width={39.7366}
      height={11.0497}
      rx={1.71161}
      fill="white"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <rect
      x={89.6693}
      y={81.242}
      width={4.55288}
      height={4.55352}
      rx={0.640805}
      fill="#38D695"
      stroke="#37363F"
      strokeWidth={0.86}
    />
    <mask
      id="path-13-inside-5_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={81.8945}
        width={18.4038}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={81.8945}
      width={18.4038}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-13-inside-5_16632_43168)"
    />
    <mask
      id="path-14-inside-6_16632_43168"
      fill="white"
    >
      <rect
        x={96.8174}
        y={84.0601}
        width={10.8258}
        height={1.0827}
        rx={0.535403}
      />
    </mask>
    <rect
      x={96.8174}
      y={84.0601}
      width={10.8258}
      height={1.0827}
      rx={0.535403}
      fill="#37363F"
      stroke="#37363F"
      strokeWidth={1.0827}
      mask="url(#path-14-inside-6_16632_43168)"
    />
    <path
      d="M84.5193 52.1201H80.5789C76.3932 52.1201 73 55.5133 73 59.699V59.699C73 63.8848 76.3932 67.278 80.5789 67.278H84.5193"
      stroke="#37363F"
      strokeWidth={0.86}
      strokeDasharray="1.61 1.61"
    />
    <path
      d="M141.221 90.3802L143.563 92.7217L145 91.2845L142.658 88.9431L144.279 87.7897L137.963 85.6841L140.068 92.0009L141.221 90.3802Z"
      fill="#46E8A8"
      stroke="#37363F"
      strokeWidth={0.86}
      strokeMiterlimit={10}
    />
    <path
      d="M69 77.8178L69.3101 77.8287C70.5539 77.8743 71.7286 78.412 72.576 79.3237C73.4233 80.2353 73.8739 81.4461 73.8287 82.6899L73.8163 83L73.8287 82.6899C73.8511 82.074 73.9946 81.4685 74.251 80.908C74.5075 80.3476 74.8718 79.8432 75.3232 79.4236C75.7746 79.004 76.3043 78.6774 76.882 78.4626C77.4596 78.2477 78.074 78.1487 78.6899 78.1713L79 78.1837L78.6899 78.1713C78.074 78.1489 77.4685 78.0054 76.9081 77.749C76.3476 77.4925 75.8432 77.1282 75.4236 76.6768C75.004 76.2254 74.6774 75.6957 74.4626 75.118C74.2477 74.5404 74.1487 73.926 74.1714 73.3101L74.1822 73L74.1714 73.3101C74.149 73.926 74.0054 74.5315 73.749 75.092C73.4925 75.6524 73.1282 76.1568 72.6768 76.5764C72.2254 76.996 71.6957 77.3226 71.118 77.5375C70.5404 77.7523 69.926 77.8513 69.3101 77.8287L69 77.8178Z"
      fill="white"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M133 56.3725L133.217 56.3801C134.088 56.412 134.91 56.7884 135.503 57.4266C136.096 58.0647 136.412 58.9123 136.38 59.7829L136.371 60L136.38 59.7829C136.396 59.3518 136.496 58.9279 136.676 58.5356C136.855 58.1433 137.11 57.7902 137.426 57.4965C137.742 57.2028 138.113 56.9742 138.517 56.8238C138.922 56.6734 139.352 56.6041 139.783 56.6199L140 56.6286L139.783 56.6199C139.352 56.6043 138.928 56.5038 138.536 56.3243C138.143 56.1448 137.79 55.8897 137.497 55.5737C137.203 55.2577 136.974 54.887 136.824 54.4826C136.673 54.0783 136.604 53.6482 136.62 53.2171L136.628 53L136.62 53.2171C136.604 53.6482 136.504 54.0721 136.324 54.4644C136.145 54.8567 135.89 55.2098 135.574 55.5035C135.258 55.7972 134.887 56.0258 134.483 56.1762C134.078 56.3266 133.648 56.3959 133.217 56.3801L133 56.3725Z"
      fill="white"
      stroke="#37363F"
      strokeWidth={0.8}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgPlaybookPlaceholder = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgPlaybookPlaceholder;
